import { dialog } from "../../../../nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { restUseCase } from "../../../../usecases/rest";
import QRCode from "qrcode";
import {
  base64ToBlob,
  formatDate,
  formatDateUTC,
  formatTimeUTC,
  generateEmailBody,
  generateOnboardEmail,
  genererateSurveyEmailBody,
  genererateRejectionEmailBody,
} from "../../utils/utils";
import { saveImageUseCase } from "../../../../usecases/file";
import DialogSuccess from "../../components/DialogSuccess";
import DialogAssignCoordinator from "../../components/DialogAssignCoordinator";

class MyWalkInApplicantFormPresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    getObjectUseCase,
    findObjectUseCase,
    deleteObjectUseCase,
    auditUseCase
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.auditUseCase = auditUseCase;

    this.personal = {};
    this.employmentBackground = [];
    this.characterReferences = [];
    this.recruiter = null;
    this.image = "";

    this.onChangeEmployment = this.onChangeEmployment.bind(this);
    this.onChangecharacteref = this.onChangecharacteref.bind(this);
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.getClients();
    this.getLocations();
    this.getRecruiters();
    this.getOnBoard();

    this.employmentBackground = [...(this.object.employmentBackground || [])];
    this.characterref = [...(this.object.characterReferences || [])];
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    console.log("qwe", id);
    if (id) {
      const params = {
        include: [
          "employmentBackground",
          "characterReferences",
          "users",
          "employees",
          "job_posting",
          "positionDesired.job_posting",
          "applicant.employees",
          "recruiter.employees",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        console.log("jkjk", this.object);
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async getOnBoard() {
    const user = this.view.getCurrentUser();
    const now = new Date();
    const utcMidnight = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    utcMidnight.setUTCHours(0, 0, 0, 0);

    const todayISO = utcMidnight.toISOString();
    const collection = "on_boarding";
    const query = {
      // where: { "recruiter.id": user?.id },
      where: { assignedDate: { $gt: todayISO } },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.view.setState({ onBoards: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getClients() {
    const collection = "clients";

    try {
      if (this.findObjectUseCase?.abort) {
        this.findObjectUseCase.abort();
      }
      const clients = await this.findObjectUseCase.execute(collection);

      this.view.setState((prevState) => {
        if (JSON.stringify(prevState.clients) !== JSON.stringify(clients)) {
          return { clients: clients };
        }
        return null;
      });
    } catch (error) {
      console.error("Error fetching clients:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getRecruiters() {
    const collection = "users";
    const query = {
      include: ["employee"],
      where: { "roles.id": "Recruiter" },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.view.setState({ recruiters: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  showImage() {
    dialog.fire({
      html: (
        <>
          <div className="d-flex justify-content-center mt-2">
            <img
              src="/emailLoading2.gif"
              alt="loading"
              style={{ width: "200px", height: "200px" }}
            />
          </div>
          <div className="text-center mt-3">
            <p style={{ color: "#D18237" }}>Sending email... Please wait...</p>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async getJobPositions() {
    const collection = "job_posting";
    const now = new Date();
    const utcMidnight = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    utcMidnight.setUTCHours(0, 0, 0, 0);

    const todayISO = utcMidnight.toISOString();

    try {
      if (this.findObjectUseCase?.abort) {
        this.findObjectUseCase.abort();
      }

      const objects = await this.findObjectUseCase.execute(collection, {
        where: { deadline: { $gte: todayISO } },
      });

      this.view.setState((prevState) => {
        if (JSON.stringify(prevState.positions) !== JSON.stringify(objects)) {
          return { positions: objects };
        }
        return null;
      });
    } catch (error) {
      console.error("Error fetching job positions:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async generateQRCode(data) {
    try {
      return await QRCode.toDataURL(data);
    } catch (err) {
      console.error("Error generating QR Code", err);
      return null;
    }
  }

  async getUserEmployee(id) {
    const collection = "employees";
    const query = {
      where: {
        id: id,
      },
    };
    const response = await this.findObjectUseCase.execute(collection, query);
    return response[0];
  }

  onChangeEmployment(value, field, id = crypto.randomUUID()) {
    let index = this.employmentBackground.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.employmentBackground.push({ id });
      index = this.employmentBackground.length - 1;
    }
    this.employmentBackground[index][field] = value;
  }

  onChangecharacteref(value, field, id = crypto.randomUUID()) {
    let index = this.characterReferences.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.characterReferences.push({ id });
      index = this.characterReferences.length - 1;
    }
    this.characterReferences[index][field] = value;
  }

  // onChangePersonal(value, field) {
  //   this.personal[field] = value;
  //   const isAddressSame = this.view.state.isAddressSame;
  // }

  deleteImage() {
    delete this.personal["image1"];
  }

  syncAddress(data) {
    data["permanent_houseNumber"] = data["present_houseNumber"];
    data["permanent_street"] = data["present_street"];
    data["permanent_subdivision"] = data["present_subdivision"];
    data["permanent_barangay"] = data["present_barangay"];
    data["permanent_city"] = data["present_city"];
    data["permanent_province"] = data["present_province"];
    data["permanent_zipCode"] = data["present_zipCode"];
    data["telephone"] = data["present_telephone"];
  }
  onChangePersonal(value, field) {
    this.personal[field] = value;
    console.log(this.personal);
  }

  onChangeRecruiter(event) {
    const selectedRecruiterId = event.target.value;
    this.recruiter = selectedRecruiterId;
  }

  onChangeJobPosition(event) {
    const positionTitle = event.target.value;
    this.position = positionTitle;
  }

  removeEmployment(id) {
    delete this.employmentBackground[id];
  }

  removeCharacterRef(id) {
    delete this.characterref[id];
  }

  validateInputs() {
    const uploadedImage = this.view.state.image;
    if (!this.personal["coe"] || this.personal["coe"].trim() === "") {
      return false;
    }

    if (
      !this.personal["trainingCertificate"] ||
      this.personal["trainingCertificate"].trim() === ""
    ) {
      return false;
    }

    return true;
  }

  removeAllIsUntilPresentEmployment(data) {
    data.employmentBackground = data.employmentBackground.map((entry) => {
      const { isUntilPresentEmployment, ...rest } = entry;

      if (isUntilPresentEmployment === true) {
        delete rest.dateEmployedTo;
      }

      return rest;
    });
  }

  exludedFields(data) {
    if (data.isUntilPresent === true) {
      delete data.yearEndDateHs;
    }
    if (data.isUntilPresentCol === true) {
      delete data.yearEndDateCol;
    }
    delete data.isUntilPresent;
    delete data.isUntilPresentCol;
  }

  async onUpdate() {
    const { object, isAddressSame } = this.view.state;
    const user = this.view.getCurrentUser();

    const data = {
      ...this.object,
      ...this.personal,
      characterReferences: [
        ...this.characterReferences,
        ...(object.characterReferences || []),
      ],
      employmentBackground: [
        ...this.employmentBackground,
        ...(object.employmentBackground || []),
      ],
      recruiter: { id: object.recruiter?.id },
      applicant: { id: object.applicant?.id },
    };
    this.exludedFields(data);
    this.removeAllIsUntilPresentEmployment(data);
    if (isAddressSame) {
      this.syncAddress(data);
    }

    try {
      this.view.showProgress();

      await Promise.all([
        ...data.employmentBackground.map((employment) =>
          this.upsertUseCase.execute("employment_background", employment)
        ),
        ...data.characterReferences.map((ref) =>
          this.upsertUseCase.execute("character_references", ref)
        ),
      ]);
      const deleteData = await this.deleteObjectUseCase.execute(
        "walkIn_applicants",
        data.id
      );
      const applicationData = await this.upsertUseCase.execute(
        "walkIn_applicants",
        data
      );

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "My Listings",
        description: "Updated the application details",
        application_id: applicationData?.id,
      };

      await this.auditUseCase.execute(auditObject);

      this.view.successModal("Application updated successfully");
      this.view.setState({ object: applicationData });
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.hideProgress();
    }
  }

  async getLocations() {
    const collection = "locations";

    try {
      if (this.findObjectUseCase?.abort) {
        this.findObjectUseCase.abort();
      }

      const objects = await this.findObjectUseCase.execute(collection);

      this.view.setState((prevState) => {
        if (JSON.stringify(prevState.positions) !== JSON.stringify(objects)) {
          return { locations: objects };
        }
        return null;
      });
    } catch (error) {
      console.error("Error fetching locations:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }
  async getRecruiter(id) {
    if (!id) return null;

    const collection = "users";
    const params = { include: ["all"] };

    try {
      this.view.showProgress();
      return await this.getObjectUseCase.execute(collection, id, { params });
    } catch (error) {
      this.view.showError(error);
      return null;
    } finally {
      this.view.hideProgress();
    }
  }

  async handleBackToPoll() {
    const collection = "reprocess_applicants";
    const currentId = this.view.getCurrentUser();
    const currentUser = await this.getRecruiter(currentId.id);
    const user = this.view.getCurrentUser();

    if (!this.object?.id) {
      console.error("Error: Missing object ID");
      this.view.showError("Failed to reprocess: Missing object ID.");
      return;
    }

    const { recruiter, interviewForm, image2, ...updatedObject } = this.object;
    const { remarks } = this.view.state;

    updatedObject.id = this.object?.id;
    updatedObject.status = "New";
    updatedObject.interviewCoordinator = "reprocess";
    updatedObject.applicant = {
      id: updatedObject?.applicant?.id,
    };
    updatedObject.prevInterviewForm = { id: this.object?.interviewForm?.id };
    updatedObject.previousRecruiter = `${currentUser?.employee?.firstName} ${currentUser?.employee?.lastName}`;
    updatedObject.pollRemarks = remarks;

    try {
      this.view.showProgress();

      await this.deleteObjectUseCase.execute(
        "walkIn_applicants",
        this.object.id
      );

      const applicationData = await this.upsertUseCase.execute(
        collection,
        updatedObject
      );

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "My Listings",
        description: "Back To Poll",
        application_id: applicationData?.id,
      };

      await this.auditUseCase?.execute(auditObject);

      dialog.fire({
        html: (
          <DialogSuccess
            message={"The application has been successfully removed"}
          />
        ),
        footer: false,
      });

      this.view.navigateTo("/me/recruiter/walk-in-applicants");
    } catch (error) {
      console.error("Error in handleBackToPoll:", error);
      this.view.showError("An error occurred");
    } finally {
      this.view.hideProgress();
    }
  }

  async navigateToForm() {
    const selectedPosition = this.view.state.selectedPosition;
    const datas = this.object;
    const object = this.view.state.object;
    const user = this.view.getCurrentUser();

    if (datas?.interviewForm) {
      this.view.navigateTo(`/interview/form/walkIn/${object?.id}`);
      return;
    }
    if (selectedPosition != "") {
      try {
        let application = {};

        application = {
          ...datas,
          positionApplied: selectedPosition,
          applicant: {
            id: datas?.applicant?.id,
          },
          recruiter: {
            id: datas?.recruiter?.id,
          },
        };

        console.log(application);
        const interviewFormData = await this.upsertUseCase.execute(
          "walkIn_applicants",
          application
        );

        const auditObject = {
          user: { id: user?.id },
          action: "UPDATE",
          module: "My Listings",
          description: "Updated the applied position",
          application_id: this.object?.id,
        };

        await this.auditUseCase?.execute(auditObject);

        if (interviewFormData) {
          dialog.close();
          this.view.navigateTo(`/interview/form/walkIn/${object?.id}`);
        }
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    } else {
      dialog.close();
      this.view.navigateTo(`/interview/form/walkIn/${object?.id}`);
    }
  }
  async saveObject(datas) {
    const user = this.view.getCurrentUser();
  }
  goBack() {
    sessionStorage.removeItem("interviewDatasWalkIn");
    this.view.navigateTo(`/me/recruiter/walk-in-applicants`);
  }

  async continueSubmit() {
    const { coordinatorId } = this.view.state;
    const email = this.object?.applicant?.email || this.object?.email;
    const location = this.view.state.location;
    const client = this.view.state.client;
    const deployeAt = `${location}, ${client}`;
    const user = this.view.getCurrentUser();

    const applicantName = `${this.object?.firstName} ${this.object?.lastName}`;

    const report = {
      recruiter: { id: this.object?.recruiter?.id },
      applicant: applicantName,
      client: client,
      location: location,
      status: "qualified",
    };

    if (coordinatorId != "") {
      this.object.coordinator = { id: coordinatorId };
      this.object.applicant = { id: this.object?.applicant?.id };
      this.object.recruiter = { id: this.object?.recruiter?.id };
      this.object.interviewForm = { id: this.object?.interviewForm?.id };
      this.object.deployedAt = deployeAt;
      this.object.interviewCoordinator = "walkIn";
      this.object.status = "For Coordinator";

      try {
        await this.upsertUseCase.execute("recruiters_report", report);
        const coordinatorData = await this.upsertUseCase.execute(
          "walkIn_applicants",
          this.object
        );

        this.view.setState({ object: coordinatorData });

        dialog.close();

        await this.sendSurveyEmail(
          this.object?.firstName,
          this.object?.recruiter?.id,
          email
        );

        const auditObject = {
          user: { id: user?.id },
          action: "UPDATE",
          module: "My Listings",
          description: "Assigned to a Coordinator",
          application_id: this.object?.id,
        };

        await this.auditUseCase?.execute(auditObject);

        this.view.hideProgress();
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
        console.log(error);
      }
    } else {
      this.view.showDialogWarning("All fields are required.");
    }
  }

  async handleClickOnboard(startDateTime, endDateTime, dateAssigned) {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const getUserEmployee = await this.getUserEmployee(user.employee.id);
    const applicantId = this.object.id || this.view.getObjectId();
    const getApplicantEmail =
      this.object?.applicant?.email || this.object?.email;

    const firstName = this.object?.firstName;
    const startTimeFormatted = new Date(startDateTime).toLocaleTimeString(
      "en-US",
      {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }
    );

    const endTimeFormatted = new Date(endDateTime).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    const formattedDate = new Date(dateAssigned).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const dateStr = `${startTimeFormatted} - ${endTimeFormatted}`;

    if (!applicantId) return;

    this.object.onBoardStartTime = startDateTime;
    this.object.onBoardEndTime = endDateTime;
    this.object.status = "On-boarding";

    this.object.applicant = {
      id: this.object?.applicant?.id,
    };
    this.object.recruiter = {
      id: this.object?.recruiter?.id,
    };
    this.object.coordinator = {
      id: this.object?.coordinator?.id,
    };

    delete this.object.applicant.employee;

    try {
      const data = await this.upsertUseCase.execute(collection, this.object);

      if (!data || typeof data !== "object") {
        console.warn("Invalid response data");
        return;
      }

      await this.sendOnboardEmail(
        firstName,
        formattedDate,
        dateStr,
        getApplicantEmail
      );

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "My Listings",
        description: "Assigned to an onboarding",
        application_id: this.object?.id,
      };

      await this.auditUseCase?.execute(auditObject);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  async sendSurveyEmail(firstname, recruiterId, getApplicantEmail) {
    const method = "POST";
    const path = "/send-email/d16bcf82-2a04-4eb0-bff8-139d65a4ae56";

    const obj = {
      to: getApplicantEmail,
      subject: " We Value Your Feedback – Recruitment Satisfaction Survey",
      body: genererateSurveyEmailBody(firstname, recruiterId),
    };

    try {
      this.showImage();
      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.successModal(response.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async sendOnboardEmail(firstname, date, time, getApplicantEmail) {
    const method = "POST";
    const path = "/send-email/d16bcf82-2a04-4eb0-bff8-139d65a4ae56";

    const obj = {
      to: getApplicantEmail,
      subject:
        "Onboarding Schedule and Instructions – LGS Staff Management Services Inc.",
      body: generateOnboardEmail(firstname, date, time),
    };

    try {
      this.showImage();
      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.successModal(response.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async handleToReprocess() {
    const currentCollection = this.view.getCollectionName();
    const toCollection = "reprocess_applicants";
    const objectId = this.object.id || this.view.getObjectId();
    const object = { ...this.object };
    const user = this.view.getCurrentUser();

    object.applicant = { id: object.applicant?.id };
    object.recruiter = { id: object.recruiter?.id };
    object.interviewForm = { id: object.interviewForm?.id };
    try {
      await this.deleteObjectUseCase.execute(currentCollection, objectId);

      const result = await this.upsertUseCase.execute(toCollection, object);

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "My Listings",
        description: `Moved to "My Re-Process"`,
        application_id: this.object?.id,
      };

      await this.auditUseCase?.execute(auditObject);

      if (result) {
        this.view.successModal(
          `Application has been successfully put to "My Re-Process".`
        );
        this.view.navigateTo("/me/recruiter/walk-in-applicants");
      }
    } catch (error) {
      this.view.showError(error);
      console.error("Error in handleToReprocess:", error);
    }
  }

  async sendRejectionEmail(firstname, positionApplied, getApplicantEmail) {
    const method = "POST";
    const path = "/send-email/d16bcf82-2a04-4eb0-bff8-139d65a4ae56";

    const obj = {
      to: getApplicantEmail,
      subject: "Thank you for applying!",
      body: genererateRejectionEmailBody(firstname, positionApplied),
    };

    try {
      this.showImage();
      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.successModal(response.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async rejectApplication() {
    const { rejectionReason } = this.view.state;
    const updatedObject = {
      ...this.object,
      status: "Not Hired",
      rejectionReason: rejectionReason,
    };
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    const { firstName, positionApplied, email } = this.object;

    updatedObject.applicant = { id: this.object?.applicant?.id };
    updatedObject.recruiter = { id: this.object?.recruiter?.id };
    if (this.object?.coordinator) {
      updatedObject.coordinator = { id: this.object?.coordinator?.id };
    }
    if (this.object?.interviewForm) {
      updatedObject.interviewForm = { id: this.object?.interviewForm?.id };
    }

    try {
      const object = await this.upsertUseCase.execute(
        collection,
        updatedObject
      );

      this.view.setObject(object);
      this.object = object;

      dialog.close();
      await this.sendRejectionEmail(firstName, positionApplied, email);

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "My Listings",
        description: "Application Rejected",
        application_id: this.object?.id,
      };

      await this.auditUseCase?.execute(auditObject);
    } catch (error) {
      console.error("Failed to update object: ", error);
    }
  }
}

export default MyWalkInApplicantFormPresenter;
